import { useReadQuery } from '@apollo/client';
import { Button } from '@synoptic/ui-kit/button/button.js';
import { useIsLaptop, useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { useState } from 'react';
import { UnauthenticatedActionDrawer } from '@/components/auth-guard/unauthenticated-action-drawer.tsx';
import { UnauthenticatedActionModal } from '@/components/auth-guard/unauthenticated-action-modal.tsx';
import { LayoutCard } from '@/components/layout/card.tsx';
import { StreamLabel } from '@/components/post-label/stream-label.tsx';
import { BannerSocialActions } from '@/components/streams/stream-banner/banner-social-actions.tsx';
import { UnauthorizedStreamBannerContent } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner-content.tsx';
import {
  buttonsBlock,
  freeBannerActionsBlock,
  followStreamButton,
  labelContainer,
  freeStreamBannerFooter,
  streamBannerCard,
} from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';
import {
  UnauthenticatedStreamLoaderData,
  useStreamLoaderData,
} from '../loader.ts';
import { StreamBannerEmptyState } from './stream-banner-empty-state.tsx';

export const UnauthorizedStreamBanner = () => {
  const [modalOpen, onModalOpenChange] = useState(false);
  const isLaptop = useIsLaptop();

  const { streamQueryRef }: UnauthenticatedStreamLoaderData =
    useStreamLoaderData();
  const {
    data: { stream },
  } = useReadQuery(streamQueryRef);

  const isTablet = useIsTablet();

  if (!stream) return <StreamBannerEmptyState />;

  return stream ? (
    <LayoutCard className={streamBannerCard}>
      <div>
        <UnauthorizedStreamBannerContent stream={stream} />
        <div className={labelContainer}>
          <StreamLabel label={stream.label} streamId={stream.id} />
        </div>
      </div>
      <div className={freeStreamBannerFooter}>
        <BannerSocialActions
          streamId={stream.id}
          followersCount={stream.followersCount}
        />
        <div className={freeBannerActionsBlock}>
          <div className={buttonsBlock}>
            <Button
              variant="primary"
              size={isTablet ? 'medium' : 'small'}
              className={followStreamButton}
              onClick={() => onModalOpenChange(true)}
            >
              Follow
            </Button>
          </div>
        </div>
      </div>

      {isLaptop ? (
        <UnauthenticatedActionModal
          open={modalOpen}
          onOpenChange={onModalOpenChange}
        />
      ) : (
        <UnauthenticatedActionDrawer
          open={modalOpen}
          onOpenChange={onModalOpenChange}
        />
      )}
    </LayoutCard>
  ) : null;
};
